import { useAsyncState } from './hooks';

export const threeDots = [0, 1, 2];

export { useAsyncState };
